import React, { useEffect, useState } from 'react';
import Calender from './components/Calender';
import {
  INIT_END_DATE,
  formatDate,
  monthDiff,
  formatDatetoCheckString,
  validateLeftButton,
  validateRightButton
} from './helper';
import { ReactComponent as ForwardDirectionIcon } from '../../assets/icons/forward-direction.svg';
import moment from 'moment';
import { DateRange } from '../../types';

interface Props {
  rangeLimit: Array<DateRange>;
  onChange: (values: Array<number>) => void;
  value: Array<number>;
}

const MonthRangePicker = ({ onChange, value, rangeLimit }: Props): React.ReactElement => {
  const MinYear: number = parseInt(moment(rangeLimit[rangeLimit.length - 1].startDate).format('YYYY'));
  const MaxYear = parseInt(moment(rangeLimit[0].startDate).format('YYYY'));

  const [startDate, setStartDate] = useState<string>(
    moment(rangeLimit[Math.abs(value[0])].startDate).format('MMM YYYY')
  );
  const [endDate, setEndDate] = useState<string>(moment(rangeLimit[Math.abs(value[1])].startDate).format('MMM YYYY'));
  const [disabledLeftBtnLeftVariant, setDisabledLeftBtnLeftVariant] = useState<boolean>(false);
  const [disabledRightBtnLeftVariant, setDisabledRighBtnLeftVariant] = useState<boolean>(true);
  const [disabledLeftBtnRighttVariant, setDisabledLeftBtnRighttVariant] = useState<boolean>(false);
  const [disabledRightBtnRighttVariant, setDisabledRightBtnRighttVariant] = useState<boolean>(true);

  const startYearValue = parseInt(moment(rangeLimit[Math.abs(value[0])].startDate).format('YYYY'));
  const [startYear, setStartYear] = useState(startYearValue === MaxYear ? MaxYear - 1 : startYearValue);
  const endYearValue = parseInt(moment(rangeLimit[Math.abs(value[1])].endDate).format('YYYY'));
  const [endYear, setEndYear] = useState(endYearValue === startYearValue ? MaxYear : endYearValue);

  const [monthCount, setMonthCount] = useState('Selected');

  const getDateIndex = (date: string, rangeLimit: Array<DateRange>) => {
    const checkMonth = (element: any) => element.startDate === formatDatetoCheckString(date);
    return rangeLimit.findIndex(checkMonth);
  };

  const getValsArray = () => {
    return [getDateIndex(startDate, rangeLimit), getDateIndex(endDate, rangeLimit)];
  };

  useEffect(() => {
    if (endDate !== INIT_END_DATE) {
      onChange(getValsArray());
    }
  }, [endDate]);

  useEffect(() => {
    const count = monthDiff(formatDate(startDate), formatDate(endDate));
    if (count) setMonthCount(count.toString());
  }, [startDate, endDate]);

  // enabling/disabling left calendar buttons
  useEffect(() => {
    if (!validateLeftButton('left', startYear, endYear, MinYear)) setDisabledLeftBtnLeftVariant(true);
    else setDisabledLeftBtnLeftVariant(false);
    if (!validateRightButton('left', startYear, endYear, MaxYear)) setDisabledRighBtnLeftVariant(true);
    else setDisabledRighBtnLeftVariant(false);
    //eslint-disable-next-line
  }, [startYear]);

  // enabling/disabling right calendar buttons
  useEffect(() => {
    if (!validateLeftButton('right', startYear, endYear, MinYear)) setDisabledLeftBtnRighttVariant(true);
    else setDisabledLeftBtnRighttVariant(false);
    if (!validateRightButton('right', startYear, endYear, MaxYear)) setDisabledRightBtnRighttVariant(true);
    else setDisabledRightBtnRighttVariant(false);
    //eslint-disable-next-line
  }, [endYear]);

  const calendarProps = {
    minYear: MinYear,
    maxYear: MaxYear,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    startYear,
    setStartYear,
    endYear,
    setEndYear,
    disabledLeftBtnLeftVariant,
    disabledRightBtnLeftVariant,
    disabledLeftBtnRighttVariant,
    disabledRightBtnRighttVariant,
    rangeLimit
  };

  return (
    <div className="flex flex-col font-nunitoLight">
      <div className="flex justify-between items-center text-sm font-nunitoBold px-10 pb-2 ">
        <div>{startDate}</div>
        <div>
          <ForwardDirectionIcon />
        </div>
        <div>{endDate}</div>
      </div>
      <div className="text-filterList text-xs py-1 text-center mb-4">{monthCount} Months</div>
      <div className={`h-[1px] bg-borderGray`} />
      <div className="flex">
        <Calender variant="left" {...calendarProps} />
        <div className={`w-[1px] bg-borderGray`} />
        <Calender variant="right" {...calendarProps} />
      </div>
    </div>
  );
};

export default MonthRangePicker;
